<template>
	<div class="log-schedule-update-component">
		<div class="log-schedule-update-component-table-ctrls mb-4">
			<div style="max-width: 300px;" class="filter-table__input-wrap search-control">
				<input @keyup.enter="onSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск">
				<button @click="onSearch()" class="search-control__input-btn reset-btn">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
					</svg>
				</button>
			</div>

			<div class="v-selects">
				<v-select v-model="brand"
					:options="brands"
					:searchable="false"
					:deselectFromDropdown="false"
					:appendToBody="true"
					:clearable="false"
					class="ftoggle">
				</v-select>

				<v-select v-model="client"
					:options="clients"
					:searchable="false"
					:deselectFromDropdown="false"
					:appendToBody="true"
					:clearable="false"
					class="ftoggle">
				</v-select>

                <v-select v-model="deviceType"
					:options="deviceTypes"
					:searchable="false"
					:deselectFromDropdown="false"
					:appendToBody="true"
					:clearable="false"
					class="ftoggle">
				</v-select>

				<v-select v-model="timeInterval"
					:options="timeIntervals"
					:searchable="false"
					:deselectFromDropdown="false"
					:appendToBody="true"
					:clearable="false"
					class="ftoggle">
				</v-select>

			</div>
		</div>

		<table class="service-table table align-middle">
			<thead>
				<tr>
                    <th scope="col">
						<div class="form-check">
							<input class="form-check-input" type="checkbox" v-model="selectAll" @change="toggleSelectAll">
						</div>
					</th>
					<th class="col-header" scope="col" v-for="(elem, index) in thead" :key="index">
						<div style="display: flex; gap: 4px; align-items: center; justify-content: center;" class="th-inner sortable asc">
							<span style="width: 95%;">{{ elem }}</span>
							<div class="dropdown">
								<svg v-if="!['Бренд', 'Клиент', 'Действия'].includes(elem)" @click="toggleDropdown(index)"
									style="cursor: pointer;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M5 7.5L10 12.5L15 7.5" stroke="#575F6E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<div class="dropdown-menu" :class="{ 'show': dropdownVisible[index] }">
									<a class="dropdown-item" href="#" @click.prevent="sortBy('asc', elem)">По возрастанию</a>
									<a class="dropdown-item" href="#" @click.prevent="sortBy('desc', elem)">По убыванию</a>
								</div>
							</div>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="row in tbody" :key="row.id">
                    <td>
						<div class="form-check">
							<input
								class="form-check-input" 
								type="checkbox"
								:value="row.id"
								v-model="selectedRows"
								@click="selectRow"
							>
						</div>
					</td>
					<td>{{ row.last_change_date }}</td>
					<td>{{ row.time_interval }}</td>
					<td>{{ row.brand }}</td>
                    <td>{{ row.client }}</td>
                    <td>{{ row.device_type }}</td>
					<td>
						<div style="display: flex; gap: 12px;">
							<div class="table-popup__btn" @click="showDevicesModal">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M15 6.66732V4.16732C15 3.9463 14.9122 3.73434 14.7559 3.57806C14.5996 3.42178 14.3877 3.33398 14.1667 3.33398H3.33333C3.11232 3.33398 2.90036 3.42178 2.74408 3.57806C2.5878 3.73434 2.5 3.9463 2.5 4.16732V14.1673C2.5 14.3883 2.5878 14.6003 2.74408 14.7566C2.90036 14.9129 3.11232 15.0007 3.33333 15.0007H10.8333M13.3333 7.50065H15M10.8333 7.50065C10.8333 7.27964 10.9211 7.06768 11.0774 6.9114C11.2337 6.75512 11.4457 6.66732 11.6667 6.66732H16.6667C16.8877 6.66732 17.0996 6.75512 17.2559 6.9114C17.4122 7.06768 17.5 7.27964 17.5 7.50065V15.834C17.5 16.055 17.4122 16.267 17.2559 16.4232C17.0996 16.5795 16.8877 16.6673 16.6667 16.6673H11.6667C11.4457 16.6673 11.2337 16.5795 11.0774 16.4232C10.9211 16.267 10.8333 16.055 10.8333 15.834V7.50065Z" stroke="#0678F4" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<span>{{ devices.length }}</span>
							</div>
							<div class="table-popup__check">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M7.5 10L9.16667 11.6667L12.5 8.33333M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12987C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C9.01509 2.5 8.03982 2.69399 7.12987 3.0709C6.21993 3.44781 5.39314 4.00026 4.6967 4.6967C4.00026 5.39314 3.44781 6.21993 3.0709 7.12987C2.69399 8.03982 2.5 9.01509 2.5 10Z" stroke="#23BA1F" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<span>12</span>
							</div>
						</div>
					</td>

					<td>
                        <div class="table-action-buttons">
							<button class="table-action table-action_status_history m-auto align-middle" @click="showHistoryModal" title="История"></button>
							<!-- Временно закоментили, забыли куда должна вести ссылка
							<button class="table-action table-action_doc_link m-auto align-middle" title="Ссылка"></button> -->
							<button class="table-action table-action_edit m-auto align-middle" title="Редактировать"></button>
							<button class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>
						</div>
                    </td>
				</tr>
			</tbody>
		</table>

		<DeviceQuantityModal v-if="devicesModal"
			:modalTitle="'Количество устройств'"
			:devices="devices"
			@closeModal="closeDevicesModal"
		/>

		<ChangeHistoryModal v-if="historyModal"
			:modalTitle="'История изменений'"
			:history="history"
			@closeModal="closeHistoryModal"
		/>
	</div>
</template>

<script>
import ChangeHistoryModal from '../../../../modals/ChangeHistoryModal.vue';
import DeviceQuantityModal from '../../../../modals/DeviceQuantityModal.vue';

export default {
    name: 'SoftwareUpdateScheduleComponent',

    components: {
		DeviceQuantityModal, ChangeHistoryModal
	},

    emits: ['selectRow', 'closeModal'],

	data() {
		return {
			brand: 'Бренд',
			brands: ['Бренд 1', 'Бренд 2', 'Бренд 3'],

			client: 'Клиент',
			clients: ['Клиент 1', 'Клиент 2', 'Клиент 3'],

			pharmacy: 'Аптека',
			pharmacys: ['Аптека 1', 'Аптека 2', 'Аптека 3'],

			deviceType: 'Тип устройства',
			deviceTypes: ['Тип 1', 'Тип 2', 'Тип 3'],

			timeInterval: 'Интервал времени',
			timeIntervals: ['Интервал 1', 'Интервал 2', 'Интервал 3'],

			thead: ['Дата последнего изменения', 'Интервал времени', 'Бренд', 'Клиент', 'Тип устройства', 'Кол-во устройств', 'Действия'],
			tbody: [
				{id: 1, last_change_date: '01.08.2024', time_interval: '17:00:00 - 21:00:00', brand: 'Неофарм', client: 'Неофарм', pharm_number: '77-105', device_type: 'Киоск', ip: '12.90.9.87'},
                {id: 2, last_change_date: '01.08.2024', time_interval: '17:00:00 - 21:00:00', brand: 'Неофарм', client: 'Неофарм', pharm_number: '77-105', device_type: 'Киоск', ip: '12.90.9.87'},
                {id: 3, last_change_date: '01.08.2024', time_interval: '17:00:00 - 21:00:00', brand: 'Неофарм', client: 'Неофарм', pharm_number: '77-105', device_type: 'Киоск', ip: '12.90.9.87'},
                {id: 4, last_change_date: '01.08.2024', time_interval: '17:00:00 - 21:00:00', brand: 'Неофарм', client: 'Неофарм', pharm_number: '77-105', device_type: 'Киоск', ip: '12.90.9.87'},
                {id: 5, last_change_date: '01.08.2024', time_interval: '17:00:00 - 21:00:00', brand: 'Неофарм', client: 'Неофарм', pharm_number: '77-105', device_type: 'Киоск', ip: '12.90.9.87'},
                {id: 6, last_change_date: '01.08.2024', time_interval: '17:00:00 - 21:00:00', brand: 'Неофарм', client: 'Неофарм', pharm_number: '77-105', device_type: 'Киоск', ip: '12.90.9.87'},
                {id: 7, last_change_date: '01.08.2024', time_interval: '17:00:00 - 21:00:00', brand: 'Неофарм', client: 'Неофарм', pharm_number: '77-105', device_type: 'Киоск', ip: '12.90.9.87'},
                {id: 8, last_change_date: '01.08.2024', time_interval: '17:00:00 - 21:00:00', brand: 'Неофарм', client: 'Неофарм', pharm_number: '77-105', device_type: 'Киоск', ip: '12.90.9.87'},
                {id: 9, last_change_date: '01.08.2024', time_interval: '17:00:00 - 21:00:00', brand: 'Неофарм', client: 'Неофарм', pharm_number: '77-105', device_type: 'Киоск', ip: '12.90.9.87'},
			],

			currentSortColumn: '',
			currentSortOrder: '',
			dropdownVisible: Array(9).fill(false),

			selectedRows: [],
			selectAll: false,

			devicesModal: false,
			devices: [
				{id: 1, pharmacy_number: '77-100', device_name: 'Рекламный ТВ №1'},
				{id: 2, pharmacy_number: '77-101', device_name: 'Рекламный ТВ №1'},
				{id: 3, pharmacy_number: '77-102', devce_name: 'Рекламный ТВ №1'},
				{id: 4, pharmacy_number: '77-103', device_name: 'Рекламный ТВ №1'},
				{id: 5, pharmacy_number: '77-104', device_name: 'Рекламный ТВ №1'},
				{id: 6, pharmacy_number: '77-105', device_name: 'Рекламный ТВ №1'},
				{id: 7, pharmacy_number: '77-106', device_name: 'Рекламный ТВ №1'},
				{id: 8, pharmacy_number: '77-107', device_name: 'Рекламный ТВ №1'},
				{id: 9, pharmacy_number: '77-108', device_name: 'Рекламный ТВ №1'},
				{id: 10, pharmacy_number: '77-109', device_name: 'Рекламный ТВ №1'},
				{id: 11, pharmacy_number: '77-110', device_name: 'Рекламный ТВ №1'},
				{id: 12, pharmacy_number: '77-111', device_name: 'Рекламный ТВ №1'},
				{id: 13, pharmacy_number: '77-112', device_name: 'Рекламный ТВ №1'},
				{id: 14, pharmacy_number: '77-113', device_name: 'Рекламный ТВ №1'},
				{id: 15, pharmacy_number: '77-114', device_name: 'Рекламный ТВ №1'},
				{id: 16, pharmacy_number: '77-115', device_name: 'Рекламный ТВ №1'},
				{id: 17, pharmacy_number: '77-116', device_name: 'Рекламный ТВ №1'},
				{id: 18, pharmacy_number: '77-117', device_name: 'Рекламный ТВ №1'}
			],

			historyModal: false,
			history: [
				{id: 1, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 2, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 3, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 4, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 5, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 6, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 7, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 8, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 9, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 10, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 11, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 12, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 13, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 14, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 15, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
				{id: 16, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
			]
		}
	},

	methods: {
		// sortBy(order, column) {
		// 	this.currentSortColumn = this.columnMap[column];
		// 	this.currentSortOrder = order;
		// 	this.loadTable();
		// },

		toggleDropdown: function (index) {
            setTimeout(() => {
                this.dropdownVisible = this.dropdownVisible.map((visible, i) => (i === index ? !visible : false));
            }, 1)
        },

        closeDropdown(event) {
            let clickOutside = event.target.className !== 'dropdown-item';
            let dropDownOpenned = document.querySelector('.show') !== null;
            if (dropDownOpenned && clickOutside) {
                this.dropdownVisible = this.dropdownVisible.map(() => false);
            };
        },

		toggleSelectAll() {
			if (this.selectAll) {
				this.selectedRows = this.tbody.map(row => row.id);
			} else {
				this.selectedRows = [];
			}
		},

		

		showDevicesModal() {
			this.devicesModal = true;
		},

		closeDevicesModal() {
			this.devicesModal = false;
		},

		showHistoryModal() {
			this.historyModal = true;
		},

		closeHistoryModal() {
			this.historyModal = false;
		}
	},
	watch: {
		selectedRows() {
			this.$emit('selectRow', this.selectedRows);
			
		}
	},
	mounted() {
		document.addEventListener('click', this.closeDropdown);
	}
}
</script>

<style scoped lang="scss">
	.title-block {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
	}

	.page-label {
		font-size: 18px;
		font-weight: 600;
	}

	.log-schedule-update-component-table-ctrls {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 20px;
	}

	.v-selects {
		display: flex;
		flex-direction: row;
		gap: 20px;
	}
	
	.dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-item {
        font-size: 14px;
    }

    .dropdown-menu {
        padding: 0;
        position: absolute;
        min-width: 160px;
        border-radius: 5px;
        border: none;
        box-shadow: 0px 4px 16px 0px rgba(100, 100, 100, 0.2);
        z-index: 1;
    }

    .dropdown-menu a {
        color: black;
        padding: 8px 12px;
        text-decoration: none;
        display: block;
    }

    .dropdown-menu a:hover {
        background-color: #F1F7FF;
    }

    .table-action-buttons {
        display: flex;
        gap: 8px;
    }

	.col-header {
		font-size: 14px;
		font-weight: 600;
		color: #575F6E;
	}

	.table-popup {
		&__btn {
			display: flex;
			gap: 6px;
			background-color: #F1F6FF;
			border-radius: 4px;
			padding: 4px 6px;
			cursor: pointer;
		}
		&__check {
			@extend .table-popup__btn;
			background-color: white;
			cursor: default;
		}
	}
</style>